// WATestNumbersPanel.jsx — إعدادات «أرقام الاختبار» (SSOT) v1 2026-09
// قائمة مركزية (اسم+رقم) تُقرأ من كل شاشات الإرسال لزر «إرسال تجربة».
import React, { useEffect, useState, useCallback } from "react";
import { api, formatErr } from "./lib/api";
import { showToast } from "./lib/theme";

export default function WATestNumbersPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/wa-test/numbers");
      setItems(data.items || []);
    } catch (e) {
      showToast({ kind: "danger", message: formatErr(e) });
    } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const addRow = () => setItems((x) => [...x, { name: "", phone: "" }]);
  const rm = (i) => setItems((x) => x.filter((_, idx) => idx !== i));
  const upd = (i, k, v) => setItems((x) => x.map((r, idx) => (idx === i ? { ...r, [k]: v } : r)));

  const save = async () => {
    const clean = items.filter((r) => (r.name || "").trim() && (r.phone || "").trim());
    setSaving(true);
    try {
      const { data } = await api.put("/wa-test/numbers", { items: clean });
      setItems(data.items || []);
      showToast({ kind: "success", message: `✅ حُفظت ${data.items?.length ?? 0} أرقام اختبار` });
    } catch (e) {
      showToast({ kind: "danger", message: e?.response?.data?.detail || formatErr(e) });
    } finally { setSaving(false); }
  };

  if (loading) return <div data-testid="test-numbers-loading" style={{ padding: 12, color: "var(--muted)" }}>جارٍ التحميل…</div>;

  return (
    <div data-testid="wa-test-numbers-panel" style={{ border: "1px solid var(--border)", borderRadius: 14, padding: 16 }}>
      <div style={{ fontWeight: 800, fontSize: 15, marginBottom: 4 }}>🧪 أرقام الاختبار</div>
      <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 12, lineHeight: 1.8 }}>
        قائمة ثابتة تُرسَل إليها رسائل «التجربة» قبل أي حملة/استبيان/زوار متوقعين — بدل كتابة رقم يدويًا كل مرة.
        رسائل التجربة لا تُحسب على الجمهور ولا تمرّ بالسقف اليومي.
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {items.map((r, i) => (
          <div key={i} data-testid={`test-number-row-${i}`} style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <input
              data-testid={`test-number-name-${i}`}
              value={r.name} onChange={(e) => upd(i, "name", e.target.value)}
              placeholder="الاسم (مثال: شهد)" className="input"
              style={{ flex: 1, minHeight: 40, padding: "8px 12px", border: "1px solid var(--border)", borderRadius: 8 }}
            />
            <input
              data-testid={`test-number-phone-${i}`}
              value={r.phone} onChange={(e) => upd(i, "phone", e.target.value)}
              placeholder="05xxxxxxxx" dir="ltr" className="input"
              style={{ flex: 1, minHeight: 40, padding: "8px 12px", border: "1px solid var(--border)", borderRadius: 8 }}
            />
            <button data-testid={`test-number-remove-${i}`} onClick={() => rm(i)}
              style={{ border: "1px solid #dc2626", color: "#dc2626", borderRadius: 8, minHeight: 40, padding: "0 12px" }}>
              ✖
            </button>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
        <button data-testid="test-number-add" onClick={addRow} className="btn"
          style={{ border: "1px solid var(--border)", borderRadius: 8, minHeight: 40, padding: "0 14px" }}>
          ➕ إضافة رقم
        </button>
        <button data-testid="test-numbers-save" onClick={save} disabled={saving} className="btn btn-primary"
          style={{ background: "var(--brand, #0e7490)", color: "#fff", borderRadius: 8, minHeight: 40, padding: "0 18px", fontWeight: 700 }}>
          {saving ? "⏳ جارٍ الحفظ…" : "💾 حفظ"}
        </button>
      </div>
    </div>
  );
}
